var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58074 14.9974H3.45575C2.26408 14.9974 1.66406 14.3974 1.66406 13.2057V3.45575C1.66406 2.26408 2.26408 1.66406 3.45575 1.66406H7.03907C8.23074 1.66406 8.83071 2.26408 8.83071 3.45575V4.9974",
    stroke: "#1E2328",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4698 7.01665V16.3167C14.4698 17.6583 13.8031 18.3333 12.4615 18.3333H7.59478C6.25311 18.3333 5.57812 17.6583 5.57812 16.3167V7.01665C5.57812 5.67499 6.25311 5 7.59478 5H12.4615C13.8031 5 14.4698 5.67499 14.4698 7.01665Z",
    stroke: "#1E2328",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1602 4.9974V3.45575C11.1602 2.26408 11.7601 1.66406 12.9518 1.66406H16.5351C17.7268 1.66406 18.3268 2.26408 18.3268 3.45575V13.2057C18.3268 14.3974 17.7268 14.9974 16.5351 14.9974H14.4685",
    stroke: "#1E2328",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32812 9.16406H11.6615",
    stroke: "url(#paint0_linear_4917_4519)",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32812 11.6641H11.6615",
    stroke: "url(#paint1_linear_4917_4519)",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 18.3359V15.8359",
    stroke: "#1E2328",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4917_4519",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4917_4519",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.7a6e82cd1c26ede23f5070637e3819bb.svg";
export { ForwardRef as ReactComponent };